import React, { Component } from "react";
import PropTypes from "prop-types";
import { Tag } from "antd";
import { Spinner } from "../spinner";

const ACCOUNT_STATUS = {
  ACTIVE: "ACTIVE",
  REQUIRES_VERIFICATION: "REQUIRES_VERIFICATION",
  LOCKED: "LOCKED"
};

class EmailVerificationInfo extends Component {
  state = {
    user_account: {
      loading: true,
      error: false,
      errorMsg: "",
      data: null
    }
  };

  componentDidMount() {
    const { appsAPI } = this.props;

    const self = this;

    appsAPI
      .get("/useraccount")
      .then(function(response) {
        self.setState(prevState => ({
          user_account: {
            ...prevState.user_account,
            loading: false,
            data: response.data
          }
        }));
        //redirect if account locked
        if (response.data.status === ACCOUNT_STATUS.LOCKED) {
          const redirectUrl = `/accountlocked?email=${
            response.data.email
          }&message=Email+verification+required`;
          window.location = redirectUrl;
        }
      })
      .catch(error => {
        console.log("Error occurred in fetching user account", error);
        self.setState(prevState => ({
          user_account: {
            ...prevState.user_account,
            loading: false,
            error: true,
            errorMsg: error.message
          }
        }));
      });
  }

  // static getTimeTillVerification(lastSent) {
  //   if (!lastSent) return "---------";
  //   const now = moment();
  //   const lastSentP = moment(lastSent, "YYYY-MM-DDTHH:mm:ssZ").add(
  //     "270",
  //     "days"
  //   );
  //   console.log("datediff", lastSentP, now);
  //
  //   const months = lastSentP.diff(now, "months");
  //   if (months > 1) return `${months} months`;
  //
  //   const weeks = lastSentP.diff(now, "weeks");
  //   if (weeks > 1) return `${weeks} weeks`;
  //
  //   const days = lastSentP.diff(now, "days");
  //   if (days > 1) return `${days} days`;
  //
  //   const hours = lastSentP.diff(now, "hours");
  //   return `${hours} hours`;
  // }

  static getColorByStatus(status) {
    switch (status) {
      case ACCOUNT_STATUS.ACTIVE:
        return "green";
      case ACCOUNT_STATUS.REQUIRES_VERIFICATION:
        return "orange";
      case ACCOUNT_STATUS.LOCKED:
        return "red";
      default:
        return "black";
    }
  }

  render() {
    const { user_account } = this.state;
    return (
      <div>
        {user_account.loading && <Spinner />}
        {user_account.error && <div>Error: {user_account.errorMsg}</div>}
        {user_account.data && (
          <div>
            <div>
              <b>Email address</b>
              <p>{user_account.data.email}</p>
            </div>
            <div>
              <b>Account status</b>
              <div>
                <Tag
                  color={EmailVerificationInfo.getColorByStatus(
                    user_account.data.status
                  )}
                >
                  {user_account.data.status}
                </Tag>
              </div>
            </div>
            <div style={{ marginTop: "8px" }}>
              <b> Time till next verification</b>
              <p>{user_account.data.timeTillVerificationInDays} days left</p>
            </div>
          </div>
        )}
      </div>
    );
  }
}

EmailVerificationInfo.propTypes = {
  appsAPI: PropTypes.func.isRequired
};

export default EmailVerificationInfo;



// WEBPACK FOOTER //
// ./src/components/email_verification_info/EmailVerificationInfo.jsx